var React = require('react');
var Router = require('react-router');

var ClientServiceStore = require('../../stores/ClientServiceStore');
var Loading = require('../Loading');
var ServiceActions = require('../../actions/ServiceActions');
var UserStore = require('../../stores/UserStore');
var RealView = require('./RealView');

function getState(serviceId) {
    return {
        loading: ClientServiceStore.loading(),
        service: ClientServiceStore.getService(serviceId)
    };
}

var View = React.createClass({
    mixins: [Router.State],

    statics: {
        willTransitionTo: function () {
            if (!ClientServiceStore.has() && !ClientServiceStore.loading()) {
                var user = UserStore.getUser();

                // TODO: signal that we only need a single service (even though we query for
                // all of them at the moment)
                ServiceActions.getServices(user);
            }
        }
    },

    componentWillMount: function () {
        ClientServiceStore.addChangeListener(this.updateService);
    },

    componentWillReceiveProps: function () {
        this.updateService();
    },

    componentWillUnmount: function () {
        ClientServiceStore.removeChangeListener(this.updateService);
    },

    getInitialState: function () {
        return getState(this.props.params.serviceId);
    },

    render: function () {
        if (this.state.loading || !this.state.service) {
            return <Loading />;
        }

        return (
          <RealView
            service={this.state.service}
            loading={this.state.loading}
            upgradable={!this.state.service.offer || this.state.service.offer.selfUpgradable}
          />
        );
    },

    updateService: function () {
        this.setState(getState(this.props.params.serviceId));
    }
})
module.exports = View;



// WEBPACK FOOTER //
// ./app/components/ClientService/View.js